import React, { useState } from 'react';
import LazyImage from '../../components/LazyImage';

const NationalParkItem = ({ park }) => {
    const [loading, setLoading] = useState(true);
    return <>
        <div className='national-park-item-image'>
            <LazyImage
                source={park.image}
                fallbackSource={ReactAssets.FallbackImage.Listing.sm}
                alt={park.name}
                onLoad={() => setLoading(false)}
                ratio={0.75}
            />
        </div>
        <div className='national-park-item-details'>
            <h3 className='national-park-item-title'>{park.name}</h3>
            <p className='national-park-item-desc'>{park.desc}</p>
            <a className='national-park-item-url' href={park.url} target='_blank'>{`Visit Park Page ->`}</a>
        </div>
    </>
}

const NationalParkItems = ({ data, selected, setSelected }) => {
    return <div className='national-park-items'>
        {data.map((park, idx) => <div key={idx} className='national-park-item' style={{...(selected === idx ? { backgroundColor: "#B8D9B4" } : {})}} onClick={() => {
            setSelected(idx);
        }}>
            <NationalParkItem park={park} />
        </div>)}
    </div>
};

export default NationalParkItems;